// Environment-specific configuration
// API base URL and SignalR URL are now resolved dynamically per-company from companies.json
// See public/companies.json for company registry entries

const environments = {
  development: {
    REGISTRY_URL: import.meta.env.VITE_REGISTRY_URL_DEV || '/companies.json',
    PAYMENT_PROVIDER: import.meta.env.VITE_PAYMENT_PROVIDER_DEV || 'square', // 'square' or 'stripe'
    DEBUG: true
  },
  production: {
    REGISTRY_URL: import.meta.env.VITE_REGISTRY_URL_PROD || '/companies.json',
    PAYMENT_PROVIDER: import.meta.env.VITE_PAYMENT_PROVIDER_PROD || 'square', // 'square' or 'stripe'
    DEBUG: false
  }
};

// Determine current environment
const getCurrentEnvironment = () => {
  return import.meta.env.MODE || 'development';
};

// Get environment-specific config
export const getEnvironmentConfig = () => {
  const currentEnv = getCurrentEnvironment();
  return environments[currentEnv] || environments.development;
};

// Export for direct use
export default getEnvironmentConfig();